import { render, staticRenderFns } from "./endStatement.vue?vue&type=template&id=bf9c2f68&scoped=true&"
import script from "./endStatement.vue?vue&type=script&lang=js&"
export * from "./endStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9c2f68",
  null
  
)

export default component.exports